import React, { Component } from "react";
import { InnerHeader, InnerItem } from "./Inners";
import "./EndSlide.scss";

export default class EndSlide extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    render() {
        return (
            <div className="end-slider-item">
                <div className="item-container">
                {this.props.CategoryName}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/Slide/EndSlide.jsx